import { FormInstance } from 'antd';
import { ContentInterface } from 'content/library/types/contentType';
import { ApiService } from 'service/api/apiService';
import { contentApiService } from 'service/api/contentApiService';

class ClipTrailerService {
  constructor(private apiService: ApiService<ContentInterface>) {}

  async fetchById(id: number, query?: Record<string, string>): Promise<ContentInterface> {
    return await this.apiService.fetchById(id, query);
  }

  async update(id: number, form: FormInstance): Promise<ContentInterface> {
    const data = form.getFieldsValue();
    return await this.apiService.update(id, data);
  }
}

export default new ClipTrailerService(contentApiService);
